import { Link } from "react-router-dom";
import { usePageMeta } from "@/components/site/PageHero";

export default function NotFound() {
  usePageMeta("Sayfa bulunamadı");
  return (
    <section data-testid="not-found" className="flex min-h-[80svh] flex-col items-start justify-center px-5 pt-20 md:px-16">
      <p className="font-display text-[10rem] leading-none text-brand">404</p>
      <h1 className="font-display text-5xl uppercase text-white">Parkurun dışına çıktın.</h1>
      <Link to="/" data-testid="not-found-home-link" className="mt-8 bg-brand px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-brand">Ana sayfaya dön</Link>
    </section>
  );
}
